import { redirect } from "react-router";

import { store } from "../../../../..";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import { getRoster, getTeam, getTeamSchedule } from "../../../../../lib/api";
import { ILeague } from "../../../../../types/api";

export const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);

    const { user } = store.getState().auth;
    const settings = store.getState().global.settings;
    let teams = store.getState().clubhouse.teams;
    let currentTeam = selectSelectedTeam(store.getState());
    const promises = [];

    !teams.length &&
        promises.push(
            store.dispatch(
                clubhouseActions.getTeams({ userId: user?.id as number }),
            ),
        );

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    const [fetchedTeam] = await Promise.all([
        currentTeam?.id !== teamId ? getTeam(teamId) : Promise.resolve(),
        ...promises,
    ]);

    const currentYear = parseInt(
        selectSetting(store.getState(), "majorybl_current_league_year")
            ?.setting,
    );

    let team = currentTeam
        ? currentTeam.id === teamId
            ? currentTeam
            : fetchedTeam?.team
        : fetchedTeam?.team;

    let currentTeamsLeague = team?.leagues?.find(l => l.year === currentYear);

    if (team?.id !== teamId) {
        store.dispatch(clubhouseActions.setSelectedLeagueTeam(teamId));
    }

    currentTeamsLeague = currentTeam
        ? currentTeam.leagues?.find(l => l.year === currentYear)
        : team?.leagues?.find(l => l.year === currentYear);

    if (!team?.leagues) {
        return redirect("/coachs-clubhouse");
    } else {
        const [{ schedule }, roster] = await Promise.all([
            getTeamSchedule(currentTeamsLeague?.id || 0, teamId),
            getRoster(teamId, currentTeamsLeague?.id as ILeague["id"]),
        ]);

        return {
            currentTeam: team,
            teamId,
            schedule,
            players: roster.players,
        };
    }
};

export default loader;
